export const UPLOADER_SIDEBAR_MOUNT_DELAY = 300;

export const RECAPTCHA_APPEAR_DELAY = 1000;

export const PAYMENT_ONCE_RESPONSE_ARRAY = ["once", "OnceForAllUsers"];

export const ISRAEL_COUNTRY_NAME = "Israel";

export const ONE_TB_IN_KB = 1099511627776;

// export const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME || "jmbl.me";
export const DOMAIN_NAME = "www.jumbomail.me";

export const JUMBOMAIL_BUCKET_NAME = "jumbomail1";

export const IS_LOCALHOST_TREATED_AS_CUSTOM_DOMAIN = false;

export const TEST_LOCALHOST_CUSTOM_DOMAIN = "upload.perspective-media.me";
